module.exports = __webpack_public_path__ + "static/media/video.d46db2e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/img/video/video.mp4
// module id = SkG7
// module chunks = 0